import { AppBox, AppDialog, AppDialogRefType, AppTypography } from 'components'
import { FC, useRef, useState } from 'react'
import { ManageAccountDialog } from '../ManageAccountDialog'
import { AdditionalUsersTable } from '../additional-users-table/AdditionalUsersTable'
import { useSubAccountsAndDiscounts } from 'hooks'

interface Props {
  userId: string
}

export const ManageAccountAdditionalUsersCard: FC<Props> = ({ userId }) => {
  const [userIdSelected, setUserIdSelected] = useState<string>('')
  const dialogRef = useRef<AppDialogRefType>({})

  const { allSubAccounts, isGettingAccounts, resendInvitation, isInviting } = useSubAccountsAndDiscounts({
    contactId: userId,
  })
  return (
    <>
      <AppBox border={1} borderColor={'grey.200'} borderRadius={6} padding={2}>
        <AppBox borderBottom={1} borderColor={'grey.200'} paddingBottom={2}>
          <AppTypography fontWeight={700} fontSize={16}>
            Additional Users
          </AppTypography>
        </AppBox>
        <AppBox paddingTop={2}>
          <AdditionalUsersTable
            data={allSubAccounts ?? []}
            isLoading={isGettingAccounts || isInviting}
            onManageClick={(userId) => {
              setUserIdSelected(userId)
              dialogRef.current.openDialog!()
            }}
            onResendInvitationClick={resendInvitation}
          />
        </AppBox>
      </AppBox>
      <AppDialog
        maxWidth="xl"
        ref={dialogRef}
        title="Manage User"
        renderChild={(closeDialog) => (
          <ManageAccountDialog
            userId={userId}
            subAccountId={userIdSelected}
            isSubAccount={true}
            closeDialog={closeDialog}
          />
        )}
      />
    </>
  )
}
